//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 28/04/2025
// Version       : 1
// Description   : Activar/Anular productos para el reporte de combustibles
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import React, { useState } from "react";
import { UrlApi } from "../../../services/apirest";
import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Stack,
  Snackbar,
} from "@mui/material";

//Notification
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function CambiarEstadoProducto(props) {
  const isProductoActivo = props.producto.estado === 1;

  // Deshabilitar Botón
  const [disBtn, setDisBtn] = useState(false);

  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");

  // ------------------------------------------------------------------

  // FUNCIONES PARA GUARDAR EL ESTADO DE LOS PRODUCTOS
  const guardarActivo = async () => {
    await fetch(
      UrlApi +
        "/productos_reporte/" +
        encodeURIComponent(props.producto.nombre),
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          estado: 1, // Activar
        }),
      }
    )
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El producto se activó exitosamente!");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al activar el producto");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const guardarInactivo = async () => {
    await fetch(
      UrlApi +
        "/productos_reporte/" +
        encodeURIComponent(props.producto.nombre),
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          estado: 2, // Desactivar
        }),
      }
    )
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El producto se desactivó exitosamente!");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al desactivar el producto");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  // -------------------------------------

  // Manejar el guardado de estado
  const handleGuardarEstado = () => {
    if (isProductoActivo) {
      setDisBtn(true);
      guardarInactivo(props.producto); // Si está activo, lo desactiva
    } else {
      setDisBtn(true);
      guardarActivo(props.producto); // Si está inactivo, lo activa
    }
  };

  //*************************************************************************************************************************************/

  // Snackbar Notificacion
  // Cerrar el Snackbar y realizar las acciones finales
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setDisBtn(false);
    setOpenSnack(false);

    // Acciones de cierre de diálogo y actualización después de que el Snack se cierre
    props.onProductoGuardado(); // Función para obtener valores de nuevo en el componente padre
    props.handleCloseCambiarEstadoProducto();
  };

  return (
    <>
      <Box
        style={{
          borderWidth: 2,
          borderStyle: "solid",
          border: "2px solid #2B76A6",
        }}
      >
        <DialogTitle sx={{ padding: 0, marginBottom: 2 }}>
          <Box
            sx={{
              backgroundColor: "#2B76A6",
              width: "100%",
              padding: "8px 0",
              textAlign: "center",
            }}
          >
            <Typography
              sx={{
                color: "white",
                fontWeight: "bold",
              }}
            >
              {isProductoActivo ? "ANULAR" : "ACTIVAR"} PRODUCTO
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Typography align="center">{props.producto.nombre}</Typography>
        </DialogContent>
        <Typography align="center" sx={{ fontWeight: "bold" }}>
          {isProductoActivo
            ? "¿Desea anular este producto?"
            : "¿Desea activar este producto?"}
        </Typography>
        <DialogActions>
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Button
              sx={{
                backgroundColor: "#d32f2f",
                color: "#ffffff",
                "&:hover": {
                  backgroundColor: "#b71c1c", // Un rojo más oscuro en hover
                },
                "&:disabled": {
                  // Estilo para el botón en estado deshabilitado
                  backgroundColor: "rgba(0, 0, 0, 0.12)", // Color gris estándar de Material-UI
                  color: "rgba(0, 0, 0, 0.26)", // Texto gris estándar
                },
              }}
              onClick={props.handleCloseCambiarEstadoProducto}
              variant="contained"
              disabled={disBtn}
            >
              Volver
            </Button>
            <Button
              sx={{
                color: "#ffffff",
                "&:disabled": {
                  // Estilo para el botón en estado deshabilitado
                  backgroundColor: "rgba(0, 0, 0, 0.12)", // Color gris estándar
                  color: "rgba(0, 0, 0, 0.26)", // Texto gris estándar
                },
              }}
              onClick={handleGuardarEstado}
              variant="contained"
              disabled={disBtn}
            >
              {isProductoActivo ? "Anular" : "Activar"}
            </Button>
          </Box>
        </DialogActions>
      </Box>

      {/* SNACKBAR QUE SE MOSTRARÁ AL GUARDAR LOS CAMBIOS */}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default CambiarEstadoProducto;
